export default __webpack_public_path__ + "static/media/king_of_spades2.fda148e5.png";